export const Link = {
  baseStyle: {
    transition: "150ms ease-out box-shadow",
  },
};
